import { AuthService } from './../../../../service/auth.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faKey, faLock, faUser, faUserAlt } from '@fortawesome/free-solid-svg-icons';
import { Callback } from '../../login.component';
import { AgentDto, AgentOtpChannelEnum, SentOtpDto } from '../../../../service/dto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-register-otp',
	templateUrl: './register-otp.component.html',
	styleUrl: './register-otp.component.scss',
	standalone: false
})
export class RegisterOtpComponent {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();
	form!: FormGroup;
	submitting: boolean = false;
	showPassword = false;
	message?: string;
	sentOtp?: SentOtpDto;

	constructor(private authService: AuthService, private fb: FormBuilder) {

	}

	ngOnInit(): void {
		this.form = this.fb.group({
			username: [this.agent.username, [Validators.required, Validators.minLength(4)]],
			otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
		});
		this.authService.getRegistrationOtpDetailsAndResend(this.agent.username).subscribe(result => {
			this.sentOtp = result;
		});
	}

	onSubmit() {
		this.agent.otp = this.form.get('otp')!.value;

		this.submitting = true;
		this.authService.doRegisterAuthWithOtp(this.agent)
			.pipe(
				finalize(() => this.submitting = false)
			)
			.subscribe(result => {
				if (result.success == false) {
					this.message = result.message;
					return;
				}
				result.agent!.otp = this.agent.otp;
				switch (result.agent!.status) {
					case 'PendingRegistration': return this.doUpdateState.emit({ mode: 'CaptureRegistrationDetails', agent: result.agent });
					case 'PendingApproval': return this.doUpdateState.emit({ mode: 'PendingApproval', agent: result.agent });
					case 'Rejected': return this.doUpdateState.emit({ mode: 'Rejected', agent: result.agent });
					case 'Approved': return this.doUpdateState.emit({ mode: 'CapturePassword', agent: result.agent });
					case 'Blocked': return this.doUpdateState.emit({ mode: 'Blocked', agent: result.agent });
					case 'Suspended': return this.doUpdateState.emit({ mode: 'Suspended', agent: result.agent });
				}
			});
	}
	isInvalid(field: string): boolean {
		return !!(this.form.get(field)?.invalid && this.form.get(field)?.touched);
	}
	reSend(channel: AgentOtpChannelEnum) {
		this.authService.getRegistrationOtpDetailsAndResend(this.agent.username, channel).subscribe(result => {
			this.sentOtp = result;
		});
	}
}
